class TokenStorage {
  constructor() {
    this.LOCAL_STORAGE_TOKEN = "token";
    this.LOCAL_STORAGE_RECAPTCHA_TOKEN = "_grecaptcha_token";
  }

  get token() {
    return localStorage.getItem(this.LOCAL_STORAGE_TOKEN);
  }
  set token(data) {
    localStorage.setItem(this.LOCAL_STORAGE_TOKEN, data);
  }

  clear() {
    localStorage.removeItem(this.LOCAL_STORAGE_TOKEN)
  }

  get recaptchaToken() {
    return localStorage.getItem(this.LOCAL_STORAGE_RECAPTCHA_TOKEN);
  }

  set recaptchaToken(data) {
    localStorage.setItem(this.LOCAL_STORAGE_RECAPTCHA_TOKEN, data);
  }
}

export default new TokenStorage();